
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcParaGrid extends Serenity.EntityGrid<IcParaRow, any> {
        // protected getColumnsKey() { return IcParaColumns.columnsKey; }
        protected getDialogType() { return IcParaDialog; }
        protected getIdProperty() { return IcParaRow.idProperty; }
        protected getInsertPermission() { return IcParaRow.insertPermission; }
        protected getLocalTextPrefix() { return IcParaRow.localTextPrefix; }
        protected getService() { return IcParaService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            var buttons = [];

            return buttons;
        }
        

        protected createSlickGrid() {
            this.slickGrid = super.createSlickGrid();

            new Serenity.AutoColumnWidthMixin({
                grid: this
            });

            return this.slickGrid;
        }
    }
}